import { last, first, toArray, isFunction } from 'lodash-es'
import { hasEmitterList, flattenEmitters } from './sum-emitter'

const isELF = (v) => isFunction(v) && hasEmitterList(v)
const isCommonFunction = (v) => isFunction(v) && !isELF(v)

export default attachEmitters
attachEmitters.isELF = isELF
attachEmitters.attachEmitters = attachEmitters

function attachEmitters() {
  const args = toArray(arguments)

  const left = isCommonFunction(first(args))
  const func = left ? first(args) : last(args)
  const list = left ? args.slice(1) : args.slice(0, -1)
  const flat = flattenEmitters(list)

  func.emitterList = flat
  return func
}
